/**
 * Classifies a Supabase (Auth or PostgREST) HTTP status as a verdict on the
 * credential itself versus an infrastructure failure.
 *
 * Only a 4xx other than 429 says something about the token: expired or
 * malformed JWTs, revoked sessions and RLS denials. Gateway timeouts (504),
 * Cloudflare origin errors (520-527), rate limiting (429), network failures
 * (no status) and anything else mean Supabase could not answer. Treating those
 * as "invalid session" is what signs operators out mid-task, so both the Vercel
 * proxies and the browser auth provider share this single predicate.
 */
export function isDefinitiveSupabaseAuthFailure(status: unknown): boolean {
  return (
    typeof status === "number" &&
    Number.isInteger(status) &&
    status >= 400 &&
    status < 500 &&
    status !== 429
  );
}
